Librarian.Modules.iFrame = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onLoadIframe", "onResize"],

    options: {
        classPrefix: "modules-iframe-",
        src: null,
        removePadding: true,
        type: null, // This will override options, possible values: collaboration, dashboard, activityreports, salesreports, portaltracker
        args: null,
        language: "en",
        title: null
    },

    iFrameEl: null,
    oldPadding: null,

    typeOptions: {
        "collaboration": {
            desc: "collaboration",
            src: function(topicId) {
                return Librarian.path.getAppPath("collaboration") + "/collaboration.htm?libName=" + Librarian.path.getUrlLibraryName() + "#topicid=" + topicId;
            }
        },
        "activityreports": {
            desc: "activity reports",
            src: Librarian.path.getAppPath("reports") + "/activities.htm?libName=" + Librarian.path.getUrlLibraryName()
        },
        "salesreports": {
            desc: "sales reports",
            src: Librarian.path.getAppPath("reports") + "/sales.htm?libName=" + Librarian.path.getUrlLibraryName()
        },
        "reportsdashboard": {
            desc: "reports dashboard",
            src: Librarian.path.getAppPath("reports") + "/dashboard.htm?libName=" + Librarian.path.getUrlLibraryName()
        },
        "contentanalytics": {
            desc: "content analytics",
            src: Librarian.path.getAppPath("contentanalytics") + "/index.html?libName=" + Librarian.path.getUrlLibraryName()
        },
        "learn": {
            desc: "learn",
            src: Librarian.path.getAppPath("learn") + "/index.html?libName=" + Librarian.path.getUrlLibraryName()
        },
        "popupmanager": {
            desc: "popup manager",
            src: Librarian.path.getAppPath("popupmanager") + "/index.html?libName=" + Librarian.path.getUrlLibraryName()
        },
        "invitations": {
            desc: "events manager",
            src: Librarian.path.getAppPath("invitations") + "/index.html?libName=" + Librarian.path.getUrlLibraryName()
        },
        "contentanalyticsdemo": {
            desc: "content analytics demo",
            src: function() {
                var auth = "Hash YXVzZXI6T2FDeGI3VTNsVkZpOVg0RWpBWWxO"; // AUser

                return "https://demo.accent-technologies.com/webclient/apps/contentanalytics/index.html?libName=adl&auth=" + auth;
            }
        },
        "portaltracker": {
            desc: "portral tracker",
            src: Librarian.path.getAppPath("tracking") + "/dashboard.htm?libName=" + Librarian.path.getUrlLibraryName()
        },
        "portaltracker2": {
            desc: "portral tracker",
            src: function(sessionId) {
                return Librarian.path.getAppPath("portal-tracker") + "/dashboard.htm?libName=" + Librarian.path.getUrlLibraryName() + "#sesid=" + sessionId;
            }
        },
        "dynamicdatamanager": {
            desc: "dynamic data manager",
            src: Librarian.path.getAppPath("dynamicdatamanager") + "/dashboard.htm?libName=" + Librarian.path.getUrlLibraryName()
        },
        "pages": {
            desc: "pages",
            src: function(options) {
                var url = window.location.href;
                var hashIndex = url.indexOf("#");
                if (hashIndex > 0)
                    url = url.substring(0, hashIndex);

                options.baseUrl = url;

                var params = Object.toQueryString(options);

                return Librarian.path.getAppPath("pages") + "/index.html?libName=" + Librarian.path.getUrlLibraryName() + '&' + params;
            }
        },
        "magic": {
            desc: "accent magic",
            src: Librarian.path.getAppPath("magic") + "/index.html?libName=" + Librarian.path.getUrlLibraryName()
        },
        "aisearch": {
            desc: "ai search",
            src: Librarian.path.getAppPath("aisearch") + "/index.html?libName=" + Librarian.path.getUrlLibraryName()
        }
    },

    initialize: function (options, wrapperEl) {
        if (options.type) {
            options.type = options.type.toLowerCase();
            if (this.typeOptions[options.type]) {
                options = Object.merge({}, this.typeOptions[options.type], options);
                if (options.reportsSubTab) {
                    options.src = options.src + "&subtab=" + options.reportsSubTab;
                }
            }
        }

        this.setOptions(options);
        this.parent(options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        if (this.options.removePadding) {
            var mainPadEl = $("mainPanel_pad");
            if (mainPadEl) {
                this.oldPadding = mainPadEl.style.padding;
                mainPadEl.style.padding = "0";
            }
        }

        this.parent();

        this.loadIframe();
    },

    loadIframe: function() {
        if (!this.containerEl)
            return;

        this.loadingImage = new Element("div", {
            "class": "iFrameLoadingImageSpinner"
        }).inject(this.containerEl);

        var src = this.getSrc();

        this.iFrameEl = new Element("iframe", {
            "class": (this.options.classPrefix || '') + "iframe",
            "id": this.options.id + "_iframe",
            "src": src,
            "aria-label": this.options.desc
        }).injectInside(this.containerEl);

        if (this.iFrameEl.attachEvent) {
            this.iFrameEl.attachEvent('onload', this.onLoadIframe);
        }
        else {
            this.iFrameEl.addEventListener('load', this.onLoadIframe, false);
        }

        if (this.options.css)
            this.iFrameEl.setStyles(this.options.css);

        if (this.options.height == "100%") {
            this.onResize();
            window.addEvent("resize", this.onResize);
        }
    },

    onLoadIframe: function() {
        if (this.loadingImage) {
            this.loadingImage.destroy();
        }
    },

    getSrc: function() {
        var src = this.options.src,
            args = this.options.args;

        if (typeof src == "function") {
            if (typeOf(args) == "array")
                src = src.apply(this, args);
            else
                src = src(args);
        } 
        else if (typeof args == "object" && args != null) {
            src += '&' + Object.toQueryString(args);
        }

        if (!src.contains("&sname=") && Librarian.sessionName)
            src += "&sname=" + Librarian.sessionName;

        src += "&lang=" + this.options.language + '&' + String.uniqueID();

        return src;
    },

    onResize: function () {
        var wrapperEl = $("pageWrapper");
        if (wrapperEl) {
            this.containerEl.setStyle("height", wrapperEl.getHeight() + "px");
            this.containerEl.setStyle("width", "100%");
        }
    },

    destroy: function () {
        if (this.oldPadding != null) {
            var mainPadEl = $("mainPanel_pad");
            if (mainPadEl)
                mainPadEl.style.padding = this.oldPadding;
        }

        if (this.iFrameEl) {
            $(this.iFrameEl).destroy();
            this.iFrameEl = null;
        }
    }
});